import { generateTestId } from "@client-shared";

export const setSsRejectedProductsModalTestId = (identifier: string): string => generateTestId("SsRejectedProductsModal", identifier);
